/* eslint-disable import/order */
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { workflowDesignerRoute } from '@jira/router-routes__legacy-workflow-designer-routes/src/workflowDesignerRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LegacyWorkflowDesigner } from './ui/index.tsx';

export const workflowDesignerRouteEntry: Route = createEntry(workflowDesignerRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: LegacyWorkflowDesigner,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalIssuesSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		...getNavigationSidebarGlobalSettingsResources(),
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
